<textarea name="textarea" pInputTextarea [autoResize]="autoResize" [maxLength]="maxLen" [rows]="rows"
  [readonly]="ifDisabled" (keyup)="onTextAreaKeyUp($event)">
</textarea>
<small *ngIf="isShowLength" class="float-right">
  {{ textareaLength }}
  &nbsp;/&nbsp;
  <span class="p-text-primary">{{ maxLen }}</span>
</small>
